import { connect } from 'react-redux'

import coordinators from '@coordinators'
import services from '@services'

import { EditPDFModal } from '@components/common/modal'
import { PDFData } from '@types'

interface State {
  editPDF: PDFData | null
}

const mapStateToProps = (state: State) => {
  const { editPDF } = state

  return {
    children: editPDF?.children,
    title: editPDF?.title,
  }
}

const mapDispatchToProps = () => {
  const { UIService, EditPDFService } = services
  const { CloseEditPDFModal } = coordinators

  const close = CloseEditPDFModal({
    UIService,
    EditPDFService,
  })

  const flashError = UIService.FlashMessage.displayFailureMessage

  return {
    close,
    flashError,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPDFModal)
